import { IListagemDeCustosPrevisto } from "../../../Interfaces/AssistenciaTecnica/CustoPrevistoRelatorioBI/CustoPrevistoRelatorioBI";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListagemDeCustosPrevistoService() {
    return Service(
        Axios.get<Array<IListagemDeCustosPrevisto>>(
            `/assistenciatecnica/custos/listagemdecustosprevistos`
        )
    );
}

export async function getDeCustoPrevistoService(ID_CUSTO: number) {
    return Service(
        Axios.get<IListagemDeCustosPrevisto>(
            `/assistenciatecnica/custos/getcustosprevistos?ID_CUSTO=${ID_CUSTO}`
        )
    );
}

export async function CadastroDeCustoPrevistoService(
    requestBody: IListagemDeCustosPrevisto
) {
    return Service(
        Axios.post(
            `/assistenciatecnica/custos/cadastrodecustosprevistos`,
            requestBody
        )
    );
}

export async function AtualizacaoDeCustoPrevistoService(
    requestBody: Array<IListagemDeCustosPrevisto>
) {
    return Service(
        Axios.patch(
            `/assistenciatecnica/custos/atualizacaodecustosprevistos`,
            requestBody
        )
    );
}

export async function RemocaoDeCustosPrevistoService(ID: number) {
    return Service(
        Axios.delete(
            `/assistenciatecnica/custos/remocaodecustosprevistos?ID=${ID}`
        )
    );
}
